import {
    HideGlobalSettingAction,
    HIDE_GLOBAL_SETTING,
    ShowGlobalSettingAction,
    SHOW_GLOBAL_SETTING,
} from './types';

export const showGlobalSetting = (): ShowGlobalSettingAction => {
    return { type: SHOW_GLOBAL_SETTING };
};

export const hideGlobalSetting = (): HideGlobalSettingAction => {
    return { type: HIDE_GLOBAL_SETTING };
};
